import React, { useEffect, useCallback } from 'react'
import { withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import cookieOperator from 'cookie-operator';

import { LoadingSpinner } from '../../components';

function LoginSuccessPage(props) {

  const dispatch = useDispatch();

  const getAutentication = useCallback((id) => dispatch({
    type: 'GET_AUTHORIZATION',
    id: id,
  }), [dispatch]);
  
  const authentication = useSelector(state => state.authentication);

  useEffect(() => {
    if (authentication.status === 'logged_in') {
      props.history.push('/main');
    } else {
      const clientId = cookieOperator.get('clientId') !== 'undefined' 
					? cookieOperator.get('clientId') : undefined;

      if (authentication.status !== 'logged_loading' && clientId) {
        getAutentication(clientId);
        cookieOperator.remove('clientId');
      }
      if (authentication.status === 'login_unauthorized') {
        props.history.push('/login');
      }
      if(authentication.status === 'login_register') {
        props.history.push('/register');
      }
    }
  }, [props.history, authentication.status, getAutentication]);

  return <LoadingSpinner />
} 

export default withRouter(LoginSuccessPage);